import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Programs from './pages/Programs';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import Enroll from './pages/Enroll';
import Booking from './pages/Booking';
import AdminChats from './pages/AdminChats';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import FindBestFitLanding from './pages/FindBestFitLanding';
import SponsorALesson from './pages/SponsorALesson';
import Foundations from './pages/Foundations';
import FirstSplash from './pages/FirstSplash';
import PriorityEnrollment from './pages/PriorityEnrollment';
import GroupMembership from './pages/GroupMembership';
import PrivateLessons from './pages/PrivateLessons';
import AdminWaitlists from './pages/AdminWaitlists';
import AdminBlog from './pages/AdminBlog';
import AdminSponsor from './pages/AdminSponsor';
import WaitlistStatus from './pages/WaitlistStatus';
import { BlogList, BlogPost } from './pages/Blog';
import { Toaster } from './components/ui/toaster';
import ScrollToTop from './components/ScrollToTop';
import ChatBubble from './components/ChatBubble';
import ConversionAgent from './components/ConversionAgent';
import QuizProvider from './context/QuizProvider';
import useCaptureReferral from './hooks/useCaptureReferral';
import usePixelPageViews from './hooks/usePixelPageViews';
import AuthCallback from './components/admin/AuthCallback';

function Shell() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  useCaptureReferral();
  usePixelPageViews();
  // Google sign-in returns with #session_id=… — handle it before any route renders.
  if (location.hash?.includes('session_id=')) return <AuthCallback />;
  return (
    <>
      {!isAdmin && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/programs" element={<Programs />} />
        <Route path="/programs/foundations" element={<Foundations />} />
        <Route path="/programs/first-splash" element={<FirstSplash />} />
        <Route path="/programs/group-membership" element={<GroupMembership />} />
        <Route path="/programs/private-lessons" element={<PrivateLessons />} />
        <Route path="/priority-enrollment" element={<PriorityEnrollment />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/enroll" element={<Enroll />} />
        <Route path="/book" element={<Booking />} />
        <Route path="/find-best-fit" element={<FindBestFitLanding />} />
        <Route path="/sponsor-a-lesson" element={<SponsorALesson />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/admin/chats" element={<AdminChats />} />
        <Route path="/admin/waitlists" element={<AdminWaitlists />} />
        <Route path="/admin/waitlists/:program" element={<AdminWaitlists />} />
        <Route path="/admin/blog" element={<AdminBlog />} />
        <Route path="/admin/sponsor" element={<AdminSponsor />} />
        <Route path="/waitlist/status/:token" element={<WaitlistStatus />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && <ChatBubble />}
      {!isAdmin && <ConversionAgent />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <QuizProvider>
          <Shell />
        </QuizProvider>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
